import { render, staticRenderFns } from "./Callout.vue?vue&type=template&id=b470ea6a&scoped=true"
import script from "./Callout.vue?vue&type=script&lang=js"
export * from "./Callout.vue?vue&type=script&lang=js"
import style0 from "./Callout.vue?vue&type=style&index=0&id=b470ea6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b470ea6a",
  null
  
)

export default component.exports